<template>
    <v-main class="ml-6 mt-3">
        <v-row dense>
            <v-col cols="12">
                <h3>Export additional costs Qenner accommodations</h3>
            </v-col>
        </v-row>
        <v-row dense class="mt-3">
            <v-col cols="1">
                <btn_create_excel :report_program="report" :report_request="report_request" :report_params="report_params"
                    :show_progress="true" />
            </v-col>
        </v-row>
        <navBar title="Ares - Purchase partners" :home="true" type="pp"/>
    </v-main>
</template>
  
<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import btn_create_excel from "@/components/ui/buttons/btn_create_excel.vue";

export default {
    components: {
        btn_create_excel,
        navBar,
    },
    data() {
        return {
            report: "ares/json/ares/task/pp/ovrz/ovrz1.p",
            report_params: {},
            report_request: "ovrz1",
        }
    },
}

</script> 
  
  
  
  
  